const SET_ACCOUNT = 'SET_ACCOUNT';
const SET_APP_LOADING = 'SET_APP_LOADING';
const SET_SELECTED_PLANT = 'SET_SELECTED_PLANT';
const SET_SIDEBAR_EXPANDED = 'SET_SIDEBAR_EXPANDED';
const SET_SELECTED_PLANT_ID = 'SET_SELECTED_PLANT_ID';
const SET_CONTEXTUAL_MENU_ITEMS = 'SET_CONTEXTUAL_MENU_ITEMS';

// TODO: remove this comment if we keep this refactor
const SET_SELECTED_ENTRANCE_PLANT = 'SET_SELECTED_ENTRANCE_PLANT';
const SET_SELECTED_ENTRANCE_PLANT_ID = 'SET_SELECTED_ENTRANCE_PLANT_ID';

const SET_USER_PERMISSIONS = 'SET_USER_PERMISSIONS';
const SET_ADMIN_VIEW = 'SET_ADMIN_VIEW';
const SET_OFFLINE_PLANT = 'SET_OFFLINE_PLANT';
const SET_SYNC_INFO = 'SET_SYNC_INFO';

export {
  SET_ACCOUNT,
  SET_SYNC_INFO,
  SET_ADMIN_VIEW,
  SET_APP_LOADING,
  SET_OFFLINE_PLANT,
  SET_SELECTED_PLANT,
  SET_SIDEBAR_EXPANDED,
  SET_USER_PERMISSIONS,
  SET_SELECTED_PLANT_ID,
  SET_CONTEXTUAL_MENU_ITEMS,
  SET_SELECTED_ENTRANCE_PLANT, // TODO: remove this comment if we keep this refactor
  SET_SELECTED_ENTRANCE_PLANT_ID, // TODO: remove this comment if we keep this refactor
};
